export default __webpack_public_path__ + "37b282545c3bdcd035e6d0789acbc8d7.png";